<template>
  <add-edit-dialog>
    <crm-panel title="新增字典配置">
      <div class="page-buttons">
        <crm-button
          :text="'保存'"
          :disabled="isSubmitDisabled"
          @click="handleAddDictionary()">
        </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="cancelAddDictionary()">
        </crm-button>
      </div>
      <el-form
        label-width="140px"
        class="clearfix add-edit-form"
        :rules="addRules"
        ref="addForm"
        :model="addForm">
        <el-col :span="12" :offset="5">
          <el-form-item label="二级团队：" prop="teamId">
            <el-select clearable v-model="addForm.teamId">
              <el-option
                v-for="item in secondTeamList.data"
                :label="item.name"
                :value="item.teamId"
                :key="item.uid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="5">
          <el-form-item label="字典名称：" prop="categoryId">
            <el-select clearable v-model="addForm.categoryId" @change="handleCategoryChange">
              <el-option
                v-for="item in categoryList.data"
                :label="item.name"
                :value="item.uid"
                :key="item.uid">
              </el-option>
              <el-option
                v-if="allCategoryList.totalCount > categoryList.pageSize &&
                  allCategoryList.totalPages > categoryList.pageNumber"
                label="点击加载更多"
                value="点击加载更多"
                :disabled="true"
                style="cursor:pointer;">
                <span @click="handleMoreCategoryList()">点击加载更多</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="5">
          <el-form-item label="字典项名称：" prop="dictionary" class="select-dictionary">
            <el-select clearable multiple v-model="addForm.dictionary" style="width: 100%">
              <el-option
                v-for="item in dictionaryList.data"
                :label="item.name"
                :value="item.uid"
                :key="item.uid">
              </el-option>
              <el-option
                v-if="allDictionaryList.totalCount > dictionaryList.pageSize &&
                  allDictionaryList.totalPages > dictionaryList.pageNumber &&
                  dictionaryList.data.length !== 0"
                label="点击加载更多"
                value="点击加载更多"
                :disabled="true"
                style="cursor:pointer;">
                <span @click="handleMoreDictionaryList()">点击加载更多</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
  },
  data() {
    return {
      addForm: {},
      addRules: {
        teamId: [
          { required: true, message: '请选择二级团队', trigger: 'change' },
        ],
        categoryId: [
          { required: true, message: '请选择字典名称', trigger: 'change' },
        ],
        dictionary: [
          { required: true, message: '请选择字典项名称', trigger: 'change' },
        ],
      },
      categoryList: {},
      dictionaryList: {},
      isSubmitDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      secondTeamList: 'backstage/secondTeamList',
      allCategoryList: 'backstage/allCategoryList',
      allDictionaryList: 'backstage/allDictionaryList',
    }),
  },
  created() {
    this.initAddForm();
    this.getSecondTeamList();
    this.handleGetAllCategoryList();
  },
  methods: {
    ...mapActions({
      getSecondTeamList: 'backstage/getSecondTeamList',
      getAllCategoryList: 'backstage/getAllCategoryList',
      getAllDictionaryList: 'backstage/getAllDictionaryList',
      saveAddTeamConfig: 'backstage/saveAddTeamConfig',
    }),
    initAddForm() {
      this.addForm = {
        teamId: '',
        teamName: '',
        categoryId: '',
        categoryName: '',
        dictionary: [],
        addDetail: [],
      };
      this.categoryList = {
        data: [],
        pageNumber: 1,
        pageSize: 100,
      };
      this.dictionaryList = {
        data: [],
        pageNumber: 1,
        pageSize: 100,
        code: '',
      };
    },
    cancelAddDictionary() {
      this.$emit('close');
      this.initAddForm();
    },
    handleAddDictionary() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.isSubmitDisabled = true;
          this.addForm.teamName = this.secondTeamList.data.find(item =>
            item.teamId === this.addForm.teamId).name;
          this.addForm.categoryName = this.categoryList.data.find(item =>
            item.uid === this.addForm.categoryId).name;
          this.addForm.dictionary.forEach((item) => {
            const addItem = this.dictionaryList.data.find(i => i.uid === item);
            this.addForm.addDetail.push({
              dictId: addItem.uid,
              dictName: addItem.name,
            });
          });
          const { dictionary, ...params } = this.addForm;
          this.saveAddTeamConfig({
            ...params,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '新增成功',
            });
            this.cancelAddDictionary();
            this.$emit('success');
          }).finally(() => { this.isSubmitDisabled = false; });
        }
      });
    },
    handleCategoryChange(value) {
      this.addForm.dictionary = [];
      this.dictionaryList.pageNumber = 1;
      if (value) {
        this.dictionaryList.code = this.categoryList.data.find(item => item.uid === value).code;
        this.handleGetAllDictionaryList();
      } else {
        this.dictionaryList.data = [];
        this.addForm.dictionary = [];
      }
    },
    handleGetAllCategoryList() {
      this.getAllCategoryList({
        pageNumber: this.categoryList.pageNumber,
        pageSize: this.categoryList.pageSize,
      }).then(() => {
        if (this.categoryList.pageNumber === 1) {
          this.categoryList.data = [];
        }
        this.allCategoryList.results.forEach((item) => {
          this.categoryList.data.push(item);
        });
      });
    },
    handleMoreCategoryList() {
      this.categoryList.pageNumber += 1;
      this.handleGetAllCategoryList();
    },
    handleGetAllDictionaryList() {
      this.getAllDictionaryList({
        pageNumber: this.dictionaryList.pageNumber,
        pageSize: this.dictionaryList.pageSize,
        code: this.dictionaryList.code,
      }).then(() => {
        if (this.dictionaryList.pageNumber === 1) {
          this.dictionaryList.data = [];
        }
        this.allDictionaryList.results.forEach((item) => {
          this.dictionaryList.data.push(item);
        });
      });
    },
    handleMoreDictionaryList() {
      this.dictionaryList.pageNumber += 1;
      this.handleGetAllDictionaryList();
    },
  },
};
</script>

<style lang="less">
.dialog-add-teamconfig {
  padding-right: 30px;
  .dialog-footer{
    text-align: right;
  }
  .el-date-editor.el-input{
    width: 100%;
  }
  .select-dictionary{
    .el-select{
      width: 100%;
    }
  }
}
</style>
